import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PCLayout from '@/components/SaveElectric';
import H5Layout from '@/componentsH5/SaveElectric';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';

export default function Page({ SEO }: any) {
    const { isMobile, useRouter, useLang } = useGlobal();
    const router = useRouter();
    const LayoutCom = isMobile ? H5Layout : PCLayout;
    const { t } = useLang('save_electric');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if ('jp' !== router?.locale) {
            router?.replace(`${router?.locale}/404`);
        }
    }, []);

    return (
        <PageLayout theme="black">
            <SEO title={t('seo_title') || '電気代節約'} description={t('seo_desc') || '電気代節約'} />
            <SEOlinksA locale={router.locale} list={['jp']} pathname="save-on-electric-bills" />
            <GtmPageLoad />
            <LayoutCom />
        </PageLayout>
    );
}
